import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";
import { setupStore } from "./store/store.js";
import App from "./App.js";
import HouseCardGalleryBlock from "./modules/HouseCardGalleryBlock/HouseCardGalleryBlock";
import ScheduleTimeComponent from "./components/ScheduleTimeComponent/ScheduleTimeComponent";
import ReviewsCardBlock from "./modules/ReviewsCardBlock/ReviewsCardBlock";
import { BrowserRouter } from "react-router-dom";
import OpenHouseCarousel from "./components/OpenHouseCarousel/OpenHouseCarousel.jsx";

const store = setupStore();
const rootDiv = document?.getElementById("root");
const rootDiv2 = document?.getElementById("listing-slider");
const rootDiv3 = document?.getElementById("listing-history");
const reviewsDiv = document?.getElementById("listing-reviews");
const rtScheduleTours = document?.querySelectorAll(".rt-schedule-tour");
const listingsGlanceRoot = document?.querySelectorAll(".listing-glance-root");

if (listingsGlanceRoot) {
  listingsGlanceRoot.forEach((listingGlanceRoot) => {
    const rootTmp = ReactDOM.createRoot(listingGlanceRoot);
    rootTmp.render(
        <Provider store={store}>
          <App isHistory={false} container={listingGlanceRoot} />
        </Provider>
    );
  });
}

if (rootDiv) {
  const root = ReactDOM.createRoot(rootDiv);

  root.render(
    <Provider store={store}>
      <App isHistory={false} container={rootDiv} />
    </Provider>
  );
}

if (rootDiv3) {
  const root = ReactDOM.createRoot(rootDiv3);

  root.render(
    <Provider store={store}>
      <App isHistory={true} container={rootDiv3} />
    </Provider>
  );
}

if (rootDiv2) {
  const root2 = ReactDOM.createRoot(rootDiv2);
  root2.render(
    <BrowserRouter>
      <Provider store={store}>
        <HouseCardGalleryBlock container={rootDiv2} />
      </Provider>
    </BrowserRouter>
  );
}

if (reviewsDiv) {
  const root = ReactDOM.createRoot(reviewsDiv);
  root.render(
    <BrowserRouter>
      <Provider store={store}>
        <ReviewsCardBlock container={reviewsDiv} />
      </Provider>
    </BrowserRouter>
  );
}

if (rtScheduleTours) {
  rtScheduleTours.forEach((rtScheduleTour) => {
    const openhouseCarousel = document.createElement("div");
    openhouseCarousel.style.display="none";
    rtScheduleTour.parentElement.prepend(openhouseCarousel)
    const rootX = ReactDOM.createRoot(openhouseCarousel);
    rootX.render(
      <BrowserRouter>
        <Provider store={store}>
          <OpenHouseCarousel container={openhouseCarousel}/>
        </Provider>
      </BrowserRouter>)
    ;
    const root3 = ReactDOM.createRoot(rtScheduleTour);
    root3.render(
      <BrowserRouter>
        <Provider store={store}>
          <ScheduleTimeComponent />
        </Provider>
      </BrowserRouter>
    );
  });
}
